/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {MerchantAddDto} from '../models/MerchantAddDto'
import type {MerchantDetailDtoListSuccessDataResult} from '../models/MerchantDetailDtoListSuccessDataResult'
import type {MerchantDetailDtoSuccessDataResult} from '../models/MerchantDetailDtoSuccessDataResult'
import type {MerchantDetailsDtoIDataResult} from '../models/MerchantDetailsDtoIDataResult'
import type {MerchantDtoListIDataResult} from '../models/MerchantDtoListIDataResult'
import type {StringIDataResult} from '../models/StringIDataResult'
import slugify from 'slugify'
import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'
import {uploadBase64} from 'helpers/cloudinary'

export class MerchantService {
  /**
   * @returns MerchantDtoListIDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantList(): CancelablePromise<MerchantDtoListIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/List',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param id
   * @returns MerchantDetailsDtoIDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantId(
    id: number
  ): CancelablePromise<MerchantDetailsDtoIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/id/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param slug
   * @returns MerchantDetailsDtoIDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantSlug(
    slug: string
  ): CancelablePromise<MerchantDetailsDtoIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/slug/{slug}',
      path: {
        slug: slug,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param id
   * @returns StringIDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantIdSnippet(
    id: number
  ): CancelablePromise<StringIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/id/{id}/snippet',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param letter
   * @returns MerchantDtoListIDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantLetter(
    letter: string
  ): CancelablePromise<MerchantDtoListIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/letter/{letter}',
      path: {
        letter: letter,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns MerchantDetailDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static async postApiMerchantAdd(
    requestBody?: MerchantAddDto
  ): Promise<CancelablePromise<MerchantDetailDtoListSuccessDataResult>> {
    const payload = {...requestBody}

    if (requestBody.logoBase64Content) {
      const {url = null} = await uploadBase64(requestBody.logoBase64Content)
      payload['logoUrl'] = url
    }

    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/v1/stores/',
      body: {
        name: payload.name,
        contact_first_name: payload.firstName,
        contact_last_name: payload.lastName,
        contact_email: payload.email,
        stripe_payment_email: payload.stripe_payment_email?.trim() || null,
        logo_url: payload.logoUrl,
        website_url: payload.url,
        affiliate_website_url: payload.url,
        client: process.env.REACT_APP_CLIENT_ID,
        slug: `${slugify(`${payload.name?.toLowerCase()}-cp`)}`,
        location: process.env.REACT_APP_CLIENT_LOCATION,
        primary_category: process.env.REACT_APP_DEFAULT_CATEGORY_ID,
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @returns MerchantDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantGet(
    merchantId?: number
  ): CancelablePromise<MerchantDetailDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/Get',
      query: {
        merchantId: merchantId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param advertiserId
   * @returns MerchantDetailDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiMerchantGetByAdvertiser(
    advertiserId?: number
  ): CancelablePromise<MerchantDetailDtoListSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Merchant/GetByAdvertiser',
      query: {
        advertiserId: advertiserId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
